import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, MapPin, Dumbbell } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-8 pb-8 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto overflow-hidden" data-id="element-152">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-accent/10 blur-[120px] rounded-full pointer-events-none" data-id="element-153" />

      <div className="relative z-10 flex flex-col items-center text-center" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex items-center gap-2 mb-3" data-id="element-155">
          <span className="text-2xl" data-id="element-156">💎</span>
          <span className="font-display font-bold tracking-wider text-gray-600 uppercase text-sm" data-id="element-157">
            CM Digital Pro
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="font-display text-3xl md:text-4xl lg:text-5xl font-black mb-2 leading-tight text-gray-900" data-id="element-158">
          Todo tu año de{' '}
          <span className="text-brand-accent" data-id="element-159">
            fitness resuelto en 90 días.
          </span>
        </motion.h1>

        {/* Product mockup - right below title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="w-full max-w-[200px] sm:max-w-xs mb-3" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/2fmvfhA9qQSHzj4kmCvZKE/mockup.Sistema_de_fitness_para_mamas_90D_(1).png" alt="Sistema de fitness para mamás 90D" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-161" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-lg md:text-2xl text-gray-600 mb-1 font-medium" data-id="element-162">
          Para mamás reales. Desde hoy.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-sm md:text-lg text-gray-500 mb-3 max-w-2xl" data-id="element-163">
          El sistema N°1 de entrenamiento postparto en Argentina
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="bg-brand-card border border-pink-200 rounded-full px-4 py-2 mb-3 shadow-lg shadow-pink-300/20" data-id="element-164">
          <p className="font-semibold text-brand-accent text-xs md:text-sm" data-id="element-165">
            👉 90 días + mantenimiento anual + sistema completo
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-1.5 mb-4 max-w-3xl" data-id="element-166">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }, {
          icon: MapPin,
          text: 'Para mamás reales'
        }, {
          icon: Dumbbell,
          text: 'Principiante → intermedio'
        }].map((pill, i) => <div key={i} className="flex items-center gap-1 bg-white/90 border border-pink-200 rounded-full px-2.5 py-1 text-xs text-gray-600" data-id="element-167">
              <pill.icon size={12} className="text-brand-accent" data-id="element-168" />
              <span data-id="element-169">{pill.text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="w-full max-w-md flex flex-col items-center" data-id="element-170">
          <a href="#pricing" className="w-full block bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-base md:text-xl py-4 px-8 rounded-xl text-center transition-all transform hover:scale-105 shadow-[0_0_30px_rgba(233,30,140,0.3)] hover:shadow-[0_0_40px_rgba(233,30,140,0.5)] mb-4" data-id="element-171">
            QUIERO MI SISTEMA AHORA
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs text-gray-500" data-id="element-172">
            <div className="flex items-center gap-1" data-id="element-173">
              <ShieldCheck size={14} className="text-brand-success" data-id="element-174" />
              <span data-id="element-175">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-176">
              <Lock size={14} className="text-gray-600" data-id="element-177" />
              <span data-id="element-178">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-179">
              <CreditCard size={14} className="text-blue-500" data-id="element-180" />
              <span data-id="element-181">Mercado Pago</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}